import { makeStyles, Theme } from '@material-ui/core/styles';
import { red, pink, orange } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  noBorder: {
    border: 'none',
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
  },
  dataGrid1: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
    marginBottom: '10px',
    padding: '10px',
  },

  textBox: {
    marginBottom: theme.spacing(2),
    fontSize: 14,
    color: 'rgb(0 0 0 / 54%)',
  },
  tooltip: {
    width: '75px',
    height: '25px',
    fontSize: '10px',
    lineHeight: 'auto',
    text: 'center',
  },
  checkbox: {
    padding: theme.spacing(0, 1.5, 0, 0),
  },
  container: {
    width: '100%',
    display: 'block',
    boxSizing: 'border-box',
    padding: '32px',
  },
  select: {
    margin: theme.spacing(1),
    '& .MuiSelect-select:focus': {
      background: 'none',
    },
    //width: '30%',
  },
  headerBold: {
    fontWeight: 700,
  },
  boxStatus: {
    '& .MuiDataGrid-colCellTitle': {
      fontWeight: 'bold',
    },
    '& .box--pending': {
      background: 'rgb(182, 250, 199)',
    },
  },
  fixedHeight: {
    height: 240,
  },
  margin: {
    margin: theme.spacing(1),
  },
  search: {
    //margin: theme.spacing(2),
    width: '50%',
  },
  box: {
    marginBottom: theme.spacing(2),
    width: '55%',
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
  headerBtn: {
    boxShadow: 'none',
    textTransform: 'none',
    lineHeight: '36px',
    padding: `0 ${theme.spacing(3)}px`,
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  pageDesc: {
    padding: 10,
  },
  tableCheck: {
    padding: '0 !important',
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  text: {
    textAlign: 'center',
    margin: 'auto',
    color: 'grey',
  },
  rowWide: {
    position: 'relative',
    marginBottom: theme.spacing(3),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
  },
  title: {
    display: 'flex',
    width: '20%',
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(1.7),
    fontSize: 12,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  link: {
    color: '#5081FF',
  },
  submitBtn: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#E2222B',
    fontWeight: 500,
    lineHeight: '26px',

    letterSpacing: '0.46px',
    textTransform: 'capitalize',

    color: '#FFFFFF',
  },
  submitBtns: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    whiteSpace: 'nowrap',
    backgroundColor: '#5081ff',
    fontWeight: 500,
    lineHeight: '26px',
    letterSpacing: '0.46px',
    textTransform: 'capitalize',
    color: '#FFFFFF',
  },
  topText: {
    color: 'rgb(0 0 0 / 54%)',
    paddingBottom: '16px',
    fontWeight: 500,
    fontSize: 14,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnContainers: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: '#000000',
    margin: '24px 0',
    background: '#F6F6F6',
    padding: '0 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '24px',
  },
  rightCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '24px',
  },
  profilePicture: {
    borderRadius: '50%',
    width: 100,
    height: 100,
  },
  profileContainer: {
    minWidth: '100px',
    borderRadius: '50%',
    marginRight: '24px',
  },
  uploadBtnContainer: {
    minWidth: '216px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  removeBtnContainer: {
    width: '107px',
    gap: '12px',
    borderRadius: '4px',
    marginRight: '24px',
  },
  btnLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: 'black',

    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  link2: {
    background: '#5081FF',
    color: 'white',
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  boxes: {
    width: '80% !important',
  },
  border1: {
    width: '50%',
    border: '1px solid #E0E0E0',
  },
  titlecontent: {
    margin: '10px 0 10px 0',
    fontWeight: 600,
    fontSize: 16,
  },
  width50: {
    width: '50%',
  },
  mainHeading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
  },
  companyHeadTitle: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
  },
  subHeading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },

  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  titleLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    color: '#5081FF',
    cursor: 'pointer',
  },
  cellLink: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#5081FF',
    cursor: 'pointer',
    '& .MuiInputBase-input': {
      color: '#5081FF',
    },
  },
  linktitle: { color: '#5081FF' },
  cellLinkhead: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
    },
  },
  cellInputLink: {
    '& .MuiInputBase-input': {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: '#5081FF',
    },
  },
  companytitle: {
    '& .MuiInputBase-input': {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: 27,
    },
  },
}));

export const useStylesSecond = makeStyles((theme: Theme) => ({
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  gridPaper: {
    height: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabsPanel: {
    padding: 12,
    width: '100%',
  },
  tabBox: {
    //backgroundColor: '#ffffff',
    //marginTop: theme.spacing(2.5),
  },
  tab: {
    //backgroundColor: '#ffffff',
    marginTop: theme.spacing(2.5),
  },
  container: {
    width: '100%',
  },
  row: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(3.5),
  },
  titlePopSmtp: {
    width: 170,
    margin: theme.spacing(0, 5, 0, 0),
    color: 'rgb(0 0 0 / 87%)',
  },
  desc: {
    width: 320,
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  badge: {
    position: 'relative',
    left: theme.spacing(-2),
  },
  mappingSubText: {
    fontSize: '14px',
    color: '#6b7280', // soft gray
    marginTop: '4px',
  },
  selectBlock: {
    width: '100%',
    padding: theme.spacing(1, 1, 1, 3),
    border: '1px solid #E0E0E0',
    borderRadius: '4px',

    '& > div': {
      background: 'transparent',
    },
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
  selectIcon: {
    marginRight: theme.spacing(1.1),
  },
  mappingHeader: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  mappingTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.87)',
    margin: 0,
    letterSpacing: '0.15px',
  },
  tabsPanels: {
    padding: 24,
    width: '100%',
  },
}));
